
import {of as observableOf,  Observable } from 'rxjs';

import {catchError} from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { ErrorResponse, SuccessResponse } from '@shared/services/api/legacy/response';
import { ActivityFilter, IActivityLogs } from './report-model';

@Injectable()
export class ReportsService {
    constructor(private http: HttpClient) { }

    private static get URL(): string { return `${environment.dashboardApi.baseUrl}${environment.dashboardApi.prefix}`; }
    private static readonly ENDPOINT = 'reports';

    public getActivityLogs(activityFilter: ActivityFilter): Observable<SuccessResponse<IActivityLogs> | ErrorResponse> {
        return this.http
            .post<SuccessResponse<IActivityLogs>>(
                ReportsService.URL + ReportsService.ENDPOINT + '/activities',
                activityFilter)
            .pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }
}
